Vue.component('stateprofile', {
    props: { 
        selectedData: {
            type: Object
        },
        allStatesInfo: {
            default: false, required: false
        },
        fielddata: {default: false, required: false},
        districtdata: {}
    },
    computed: {
        chosenState () {
            if (this.allStatesInfo && this.selectedData && this.selectedData.selected.filters && this.selectedData.selected.filters.STATE) {
                let abbr = this.selectedData.selected.filters.STATE[0];
                let name = this.allStatesInfo[this.selectedData.selected.filters.STATE[0]].state;
                let FIPS = this.allStatesInfo[this.selectedData.selected.filters.STATE[0]].FIPS;
                let cs = this.allStatesInfo[this.selectedData.selected.filters.STATE[0]];
                cs.name = cs.state.toUpperCase();
                return cs;
            }

            return false;
        }
    },

});
